<template>
  <v-col :cols="12" :lg="9">
    <div class="bold-text mb-12">Attachments</div>
    <v-row>
      <v-col
        v-for="img in store?.last_attachment"
        :key="img"
        class="d-flex child-flex"
        cols="4"
      >
        <v-img
          v-if="img.file_type === 'image'"
          @click="showImage(img.file_path)"
          :lazy-src="img.file_path"
          :src="img.file_path"
          aspect-ratio="1"
          class="bg-grey-lighten-2 rounded cursor-pointer"
          cover
        >
          <template v-slot:placeholder>
            <v-row align="center" class="fill-height ma-0" justify="center">
              <v-progress-circular
                color="grey-lighten-5"
                indeterminate
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <video
          v-if="img?.file_type == 'mp4'"
          :src="img?.file_path"
          class="bg-grey-lighten-2 rounded cursor-pointer"
          style="width: 100%; height: 20rem; object-fit: cover"
          cover
          autoplay
          muted
          controls
          loop
        ></video>

        <v-card
          v-else
          class="d-flex align-center justify-center pa-1 bg-grey-lighten-4 rounded cursor-pointer"
          style="height: 3rem; width: 100%"
          @click="downloadFile(img.file_path)"
        >
          <v-icon size="40" color="primary">mdi-file-document-outline</v-icon>
          <span class="mt-2 text-subtitle-2 text-truncate">{{
            getFileName(img.file_path)
          }}</span>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
  <v-overlay v-model="dialog" location="center" />
  <v-dialog v-model="dialog" width="auto">
    <v-card max-width="auto">
      <template v-slot:text>
        <img width="100%" :src="image_preview" alt="" />
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { useEditTaskStore } from "@/store/editTaskStore";
import { VFileUpload } from "vuetify/labs/VFileUpload";

export default {
  name: "TaskAttachments",
  components: {
    VFileUpload,
  },
  data() {
    return {
      store: useEditTaskStore(),
      image_preview: "",
      dialog: false,
    };
  },
  watch: {},
  methods: {
    showImage(url) {
      this.image_preview = url;
      this.dialog = true;
    },
    showImage(url) {
      this.image_preview = url;
      this.dialog = true;
    },
    getFileName(path) {
      return path.split("/").pop();
    },
    downloadFile(url) {
      window.open(url, "_blank"); // يفتح الملف في تاب جديدة أو يحمل على حسب نوع الملف
    },
  },
};
</script>
